/* Imports */
import { API_HELPER } from "@/helpers/api.js";
import { authHeader } from "@/helpers/auth-header.js";

/* Exports */
export const BANNERS_SERVICE = {getBanners, postBanner, putBanner, getBannerById, deleteBanner};

/* Consts*/
const API_ROOT_SERVICE = "Banners";

/* Services */
function getBanners(queryParams)
{
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);

    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader() }
    };

    return API_HELPER.loggedApiCall(url, queryParams, requestOptions);
}

function postBanner(input)
{
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);

    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), "Content-Type":"application/json" },
        body: JSON.stringify(input)
    };

    return API_HELPER.loggedApiCall(url, null, requestOptions);
}

function putBanner(input)
{
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);

    const requestOptions = {
        method: 'PUT',
        headers: { ...authHeader(), "Content-Type":"application/json" },
        body: JSON.stringify(input)
    };

    return API_HELPER.loggedApiCall(url, null, requestOptions);
}

function getBannerById(id)
{
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, id]);

    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader() }
    };

    return API_HELPER.loggedApiCall(url, null, requestOptions);
}

function deleteBanner(id)
{
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, id]);

    const requestOptions = {
        method: 'DELETE',
        headers: { ...authHeader() }
    };

    return API_HELPER.loggedApiCall(url, null, requestOptions);
}
